import { Box, Button, Link, Text } from "@chakra-ui/react";
import { useState } from "react";
import { scrollToSection } from "../../helpers/scroll";
import { PREVIEW_PRIMARY_HEX } from "../../helpers/theme";
import GoogleIcon from "../primary/Icon";
import classes from "./Menu.module.scss";

export type MenuItem = {
  scrollTo?: string;
  label: string;
  children?: MenuItem[];
};

type SubMenuProps = {
  item: MenuItem;
  onClose: () => void;
};

const SubMenu = (props: SubMenuProps) => {
  const { item, onClose } = props;
  const [isOpen, setIsOpen] = useState(false);
  const hasChildren = Boolean(item.children?.length);

  const handleScroll = (scrollTo?: string) => {
    if (!scrollTo) return;

    scrollToSection(scrollTo, true);
    setIsOpen(false);
    onClose();
  };

  if (hasChildren) {
    return (
      <Box
        className={classes.menuGroup}
        onBlur={(event) => {
          const nextFocus = event.relatedTarget as Node | null;
          if (!nextFocus || !event.currentTarget.contains(nextFocus)) {
            setIsOpen(false);
          }
        }}
        onFocus={() => setIsOpen(true)}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        <Button
          aria-expanded={isOpen}
          aria-haspopup="menu"
          className={classes.menuButton}
          color="cle.muted"
          onClick={() => setIsOpen(true)}
          variant="link"
          _hover={{
            textDecoration: "none",
            color: "preview.primary",
            boxShadow: `0 2px 0 ${PREVIEW_PRIMARY_HEX}`,
          }}
          _focusVisible={{
            color: "preview.primary",
            boxShadow: `0 2px 0 ${PREVIEW_PRIMARY_HEX}`,
            outline: "none",
          }}
        >
          <Text as="span" color="inherit">
            {item.label}
          </Text>
          <GoogleIcon name="expand_more" fontSize={18} color="inherit" />
        </Button>
        <Box
          className={`${classes.dropdown} ${
            isOpen ? classes.dropdownOpen : ""
          }`}
          role="menu"
        >
          {item.children?.map((child) => (
            <Link
              key={child.label}
              className={classes.dropdownLink}
              role="menuitem"
              onClick={() => handleScroll(child.scrollTo)}
            >
              <Text color="inherit">{child.label}</Text>
            </Link>
          ))}
        </Box>
      </Box>
    );
  }

  return (
    <Link
      color="cle.muted"
      _hover={{
        textDecoration: "none",
        color: "preview.primary",
        boxShadow: `0 2px 0 ${PREVIEW_PRIMARY_HEX}`,
      }}
      onClick={() => handleScroll(item.scrollTo)}
    >
      <Text color="inherit">{item.label}</Text>
    </Link>
  );
};

export default SubMenu;
